import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface VehicleNumberInputProps {
  vehicleNumber: string;
  onVehicleNumberChange: (value: string) => void;
}

const VehicleNumberInput = ({ vehicleNumber, onVehicleNumberChange }: VehicleNumberInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="vehicleNumber">Vehicle Number</Label>
      <Input
        id="vehicleNumber"
        value={vehicleNumber}
        onChange={(e) => onVehicleNumberChange(e.target.value)}
        placeholder="Enter vehicle number"
        required
      />
    </div>
  );
};

export default VehicleNumberInput;